import * as React from 'react';
import { inject } from 'mobx-react';

import { AnalyticsStore, RouteStore, SerializedData, ContextStore } from 'bernie-core';
import { UitkButtonSize } from 'uitk-react-button';
import { UitkFullscreenDialog, UitkDialogContent } from 'uitk-react-dialog';
import { UitkToolbar, ToolbarType } from 'uitk-react-toolbar';
import { UitkScrim, UitkScrimType } from 'uitk-react-scrim';

import { SortFilter, ClearSelectionsButton } from 'components/search/sort-filter';
import { SortFilterStore, SearchCriteriaStore, AdvertisingStore } from 'stores';
import { PrimaryFloatingButtonTracked } from 'components/shared/tracked';

export interface SortFilterDialogProps {
  analytics?: AnalyticsStore;
  onDismiss: () => void;
  onOpen?: () => void;
  sortAndFilterResult: SortFilterStore;
  searchCriteriaStore?: SearchCriteriaStore;
  routeStore?: RouteStore;
  dialogId: string;
  advertisingStore?: AdvertisingStore;
  context?: ContextStore;
}

/* istanbul ignore next */
@inject('analytics', 'searchCriteriaStore', 'routeStore', 'advertisingStore', 'context')
export class SortFilterDialog extends React.Component<SortFilterDialogProps> {
  private currentSortAndFilterValues: SerializedData;

  public constructor(props: SortFilterDialogProps) {
    super(props);

    this.saveSortAndFilterValues();
  }

  private saveSortAndFilterValues = () => {
    const { sortAndFilterResult } = this.props;

    this.currentSortAndFilterValues = sortAndFilterResult.toJSON();
  };

  private restoreSavedSortAndFilterValues = () => {
    const { sortAndFilterResult } = this.props;

    sortAndFilterResult.hydrate(this.currentSortAndFilterValues);
  };

  public handleDoneButton = () => {
    const { searchCriteriaStore, routeStore, sortAndFilterResult, advertisingStore, context, analytics } = this.props;

    sortAndFilterResult.applySortAndFilter(searchCriteriaStore, routeStore, advertisingStore, context, analytics);
  };

  public onDismiss = () => {
    const { onDismiss } = this.props;

    this.restoreSavedSortAndFilterValues();
    onDismiss();
  };

  public render() {
    const { sortAndFilterResult, analytics, dialogId, onOpen } = this.props;
    const applyAction = sortAndFilterResult && sortAndFilterResult.applyAction;
    const description = sortAndFilterResult && sortAndFilterResult.dismiss && sortAndFilterResult.dismiss.description;
    const title = sortAndFilterResult && sortAndFilterResult.title;
    const applyActionLabel = applyAction && applyAction.label;
    const applyActionAnalytics = applyAction && applyAction.analytics;
    const dismissAnalytics = sortAndFilterResult.dismissAnalytics;
    const keySuffix = 'onDrawer';
    const dismissCallback = (rfrr, linkName) => {
      analytics.trackEvent(rfrr, linkName, analytics.omnitureData);
    };

    return (
      <UitkFullscreenDialog
        dialogShow={true}
        strictFullscreen={true}
        wideContent={true}
        openCallback={onOpen}
        className="custom-dialog"
      >
        <UitkToolbar
          action={this.onDismiss}
          actionContent={<ClearSelectionsButton keySuffix={keySuffix} />}
          analytics={{
            id: dismissAnalytics.rfrr,
            description: dismissAnalytics.linkName,
            callback: dismissCallback
          }}
          header={title}
          iconLabel={description}
          key={`${dialogId}-toolbar`}
          type={ToolbarType.CLOSE}
        />
        <UitkDialogContent key={`${dialogId}-content`}>
          <SortFilter key={`${dialogId}-sort-filter`} keySuffix={keySuffix} />
        </UitkDialogContent>
        <UitkScrim key={`${dialogId}-done`} type={UitkScrimType.BUTTON}>
          <PrimaryFloatingButtonTracked
            data-test-id="sort-filter-done-button"
            onClick={this.handleDoneButton}
            isFullWidth={true}
            size={UitkButtonSize.LARGE}
            text={applyActionLabel}
            {...applyActionAnalytics}
          />
        </UitkScrim>
      </UitkFullscreenDialog>
    );
  }
}
